import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';
import { Link, useSearchParams } from 'react-router-dom';
import React, { useState, useEffect, useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from '../components/CheckoutForm';
import { useMsal } from "@azure/msal-react";
import { AuthContext } from "../AuthContext";

function CheckoutPage() {
    const { accounts } = useMsal();
    const { getToken, loading } = useContext(AuthContext);

    // provide the email of B2C and not the real email (BUG)
    const email = accounts[0]?.username;
    const username = accounts[0]?.name;

    const [clientSecret, setClientSecret] = useState("");
    const [stripePromise, setStripePromise] = useState(null);
    const [paymentError, setPaymentError] = useState(null);
    const [searchParams] = useSearchParams();
    const isSuccess = searchParams.get("success") === "true";

    const [contributions, setContributions] = useState([]);

    useEffect(() => {
        if (!loading) {
            const stored = localStorage.getItem('selectedGifts');
            if (stored) {
                const parsed = JSON.parse(stored);
                const contribArray = Object.entries(parsed)
                    .filter(([_, value]) => Number(value) > 0)
                    .map(([id, value]) => ({ id, amount: Number(value) }));
                setContributions(contribArray);
            }
        }
    }, [loading]);

    useEffect(() => {
        if (!loading) {
            const updateContributions = async () => {
                if (!isSuccess) return;
                const stored = localStorage.getItem('selectedGifts');
                if (!stored) return;

                const parsed = JSON.parse(stored);
                const contributions = Object.entries(parsed)
                    .filter(([_, value]) => Number(value) > 0)
                    .map(([id, amount]) => ({ id, amount: Number(amount) }));

                const contributeEndpoint = localStorage.getItem("giftListKind") === "wedding"
                    ? "/api/contribute-item"
                    : "/api/contribute-birth-item";

                for (const item of contributions) {
                    try {
                        const token = sessionStorage.getItem("access_token") || await getToken();
                        sessionStorage.setItem("access_token", token);
                        await fetch(contributeEndpoint, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify(item),
                        });
                    } catch (err) {
                        console.error("Erreur lors de la mise à jour de l'item payé :", err);
                    }
                }
                localStorage.removeItem("selectedGifts");
                localStorage.removeItem("giftListKind");
            };
            updateContributions();
        }
    }, [isSuccess, getToken, loading]);

    useEffect(() => {
        if (!loading) {
            fetch('/api/config')
                .then((res) => res.json())
                .then((config) => {
                    setStripePromise(loadStripe(config.STRIPE_PUBLIC_KEY));
                })
                .catch((err) => {
                    console.error("Erreur lors du chargement de la config Stripe :", err);
                });

            const createIntent = async () => {
                try {
                    const token = sessionStorage.getItem("access_token") || await getToken();
                    sessionStorage.setItem("access_token", token);
                    const res = await fetch("/api/create-payment-intent", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            items: contributions,
                            email: email,
                            customer: username
                        }),
                    });
                    const data = await res.json();
                    setClientSecret(data.client_secret);
                } catch (err) {
                    console.error("Erreur lors de la création du PaymentIntent :", err);
                    setPaymentError("Une erreur est survenue lors de la préparation du paiement. Veuillez réessayer plus tard.");
                }
            };

            if (contributions.length > 0 && !isSuccess) {
                createIntent();
            }
        }
    }, [contributions, email, username, isSuccess, getToken, loading]);

    // Guard clause: wait for AuthContext to finish loading
    if (loading) {
        return <div>Chargement de l'authentification...</div>;
    }

    const totalAmount = contributions.reduce((sum, item) => sum + item.amount, 0);

    const appearance = {
        theme: 'stripe',
    };
    // Enable the skeleton loader UI for optimal loading.
    const loader = 'auto';
    
    return (
        <div>
            <div
            className="hero"
            style={{ backgroundImage: `url(${image})`, height: "250px" }}
            >
                <div className="hero-inner">
                    <div className="inner">
                    <div className="hero-line-one">
                        Contribution & Paiement
                    </div>
                    </div>
                    <Link className="more-arrow" to="#content">
                    <i className="fa fa-chevron-down"></i>
                    <span>Scroll Down</span>
                    </Link>
                </div>
            </div>
            <div className="wrap full-wrap">
                <div className="main-wrap">
                    <section className="main" style={{paddingLeft: '10px'}}>
                        {contributions.length > 0 && (
                            <div style={{ marginBottom: '20px' }}>
                                <h3>🧾 Récapitulatif de votre contribution</h3>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>ID</th>
                                            <th style={{ borderBottom: '1px solid #ccc', textAlign: 'left', padding: '8px' }}>Montant (€)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contributions.map((item) => (
                                            <tr key={item.id}>
                                                <td style={{ padding: '8px' }}>{item.id}</td>
                                                <td style={{ padding: '8px' }}>{item.amount.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td style={{ padding: '8px', fontWeight: 'bold' }}>Total</td>
                                            <td style={{ padding: '8px', fontWeight: 'bold' }}>{totalAmount.toFixed(2)} €</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <h2>Paiement</h2>
                        {paymentError && (
                            <div style={{ padding: '20px', background: '#fff3f3', border: '1px solid #ffcccc', borderRadius: '6px', marginBottom: '20px' }}>
                                <strong>Erreur :</strong> {paymentError}
                            </div>
                        )}
                            {isSuccess ? (
                                <div style={{ padding: '20px', background: '#f0fff4', border: '1px solid #c6f6d5', borderRadius: '6px' }}>
                                    <h3>🎉 Merci pour votre contribution !</h3>
                                    <p>Votre paiement a bien été confirmé.</p>
                                </div>
                            ) : clientSecret && stripePromise && (
                                <div style={{ paddingTop: '30px' }}>
                                    <Elements options={{ clientSecret, appearance, loader }} stripe={stripePromise}>
                                        <CheckoutForm />
                                    </Elements>
                                </div>
                            )}
                    </section>
                </div>
            </div>
        </div>
    )
}

export default CheckoutPage;